<template>
  <div class="order-history-item-list">
    <div class="order-history-item-list__header">
      <h3>{{ $t('ec-line018.purchaseDetail', { date: data.purchase_date }) }}</h3>
    </div>
    <div class="order-history-item-list__body">
      <cart-subscription-item v-for="item in data.items" :key="item.id" :data="item"></cart-subscription-item>
      <div class="order-history-item-list__total">
        <p>
          <span>{{ $t('common.label.total') }}</span>
          <span class="text-2xl">{{ $n(data.total, 'currency', 'ja-JP') }}</span>
        </p>
        <p>
          <span>{{ $t('common.label.subtotal') }}</span>
          <span>{{ $n(data.subtotal, 'currency', 'ja-JP') }}</span>
        </p>
        <p>
          <span>{{ $t('common.label.deliveryFee') }}</span>
          <span>{{ $n(data.shipping_fee, 'currency', 'ja-JP') }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import CartSubscriptionItem from '@/components/CartSubscriptionItem.vue'
export default {
  props: {
    data: { type: Object, default: () => ({}) },
  },
  components: { CartSubscriptionItem },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/line-web018/order-history-item-list.scss';
</style>
